import { isSiiServiceRejected } from '../../components/dataGridCells/statusSteps/SiiSteps';
import {
  ACTIVE_CESSION_STATUSES,
  CREDIT_NOTE_STATUSES,
  FINISHED_STATUS,
  invoiceStatusesToGraphqlFilter,
} from '../../constants/invoices';
import { statusToSpanish } from '../../helpers';

export const CURRENT_OPERATIONS_STATUS = invoiceStatusesToGraphqlFilter(ACTIVE_CESSION_STATUSES);

export const HISTORIC_OPERATIONS_STATUS = invoiceStatusesToGraphqlFilter(FINISHED_STATUS);

export { CREDIT_NOTE_STATUSES };

export const SII_REJECTED_WARNING = 'Rechazada en el SII';
export const CREDIT_NOTE_WARNING = 'Nota de crédito';

export const SII_REJECTED_ALERT = {
  title: 'La factura fue rechazada en el SII',
  message:
    'Ahora es tu responsabilidad restituir los fondos que fueron adelantados en esta factura. '
    + 'Contáctate con tu ejecutivo para coordinar la devolución.',
};

export const CREDIT_NOTE_ALERT = {
  title: 'La factura tiene una nota de crédito asociada',
  message:
    'La diferencia entre el monto original y lo efectivamente cobrado es ahora tu responsabilidad. '
    + 'Contáctate con tu ejecutivo para coordinar la devolución.',
};

export const hasSiiRejection = (invoice) => isSiiServiceRejected(invoice?.siiStatus);

export const hasCreditNote = (invoice) => CREDIT_NOTE_STATUSES.includes(invoice?.creditNoteStatus)
  || Boolean(invoice?.creditNotes?.length);

export const getStatusLabel = (invoice) => {
  const status = invoice?.status?.toUpperCase();
  if (status === 'FINISHED' && Number(invoice?.surplusDebt?.amount) > 0) {
    return 'Recaudada con deuda';
  }
  return statusToSpanish()[status] || invoice?.status;
};

export const getInvoiceWarning = (invoice) => {
  if (hasSiiRejection(invoice)) {
    return { text: SII_REJECTED_WARNING, alert: SII_REJECTED_ALERT };
  }
  if (hasCreditNote(invoice)) {
    return { text: CREDIT_NOTE_WARNING, alert: CREDIT_NOTE_ALERT };
  }
  return null;
};
